if (!customElements.get('pp-pot-recommendations')) {
  customElements.define('pp-pot-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.active = 'pots';
      this.tabs = [...this.querySelectorAll('[data-rec-tab]')];
      this.panels = [...this.querySelectorAll('[data-rec-panel]')];
      this.tracks = [...this.querySelectorAll('[data-rec-track]')];
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-rec-tab]');
        if (tab) this.select(tab.dataset.recTab);
        const arrow = event.target.closest('[data-rec-scroll]');
        if (arrow) this.track.scrollBy({left: Number(arrow.dataset.recScroll) * this.track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-rec-tab]');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const visible = this.tabs.filter(t => !t.hidden), index = visible.indexOf(tab);
        let next = (index + (event.key === 'ArrowLeft' ? -1 : 1) + visible.length) % visible.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = visible.length - 1;
        event.preventDefault(); this.select(visible[next].dataset.recTab); visible[next].focus();
      }, options);
      this.tracks.forEach(track => track.addEventListener('scroll', () => this.updateArrows(), options));
      this.resize = new ResizeObserver(() => this.updateArrows()); this.tracks.forEach(track => this.resize.observe(track));
      this.select('pots');
      this.loadObserver?.disconnect();
      if (this.dataset.fetchPots === 'true' || this.dataset.fetchPlants === 'true') {
        if ('IntersectionObserver' in window) {
          this.loadObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.loadObserver.disconnect(); this.loadPlants();
          }, {rootMargin: '400px 0px'});
          this.loadObserver.observe(this);
        } else this.loadPlants();
      }
    }
    get track() {return this.querySelector(`[data-rec-track="${this.active}"]`);}
    select(key) {
      if (this.tabs.find(t => t.dataset.recTab === key)?.hidden) key = 'pots';
      this.active = key;
      this.tabs.forEach(tab => {const active = tab.dataset.recTab === key; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;});
      this.panels.forEach(panel => {panel.hidden = panel.dataset.recPanel !== key;});
      this.updateArrows();
    }
    updateArrows() {
      if (!this.track) return;
      const {scrollLeft, scrollWidth, clientWidth} = this.track;
      this.querySelector('.pp-recommendations-arrows').hidden = scrollWidth <= clientWidth + 2;
      this.querySelector('[data-rec-scroll="-1"]').disabled = scrollLeft <= 1;
      this.querySelector('[data-rec-scroll="1"]').disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }
    async loadPlants() {
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('product_id', this.dataset.productId);
      url.searchParams.set('limit', '10'); url.searchParams.set('intent','related');
      const panel = this; panel.setAttribute('aria-busy','true');
      try {
        const response = await fetch(url, {signal:this.abort.signal}); if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        if (!this.isConnected) return;
        for (const key of ['pots','plants']) {
          if (this.dataset[key === 'pots' ? 'fetchPots' : 'fetchPlants'] !== 'true') continue;
          const source = html.querySelector(`[data-rec-track="${key}"]`);
          if (!source) continue;
          this.querySelector(`[data-rec-track="${key}"]`).replaceChildren(...[...source.children].map(node => document.importNode(node,true)));
        }
        this.tabs.find(tab => tab.dataset.recTab === 'plants').hidden = !this.querySelector('[data-rec-track="plants"]').children.length;
        this.querySelector('[data-rec-empty]').hidden = this.querySelector('[data-rec-track="pots"]').children.length > 0;
      } catch (error) {
        // The existing browse link remains available on a failed/empty response.
      } finally { panel.removeAttribute('aria-busy'); this.updateArrows(); }
    }
    disconnectedCallback() {this.loadObserver?.disconnect();this.abort?.abort();this.resize?.disconnect();}
  });
}
